export default __webpack_public_path__ + "static/Ogg-Roman-765c22cbe654f9f7b3fa9c1ae30cb308.woff2";